import { Alert } from 'react-bootstrap';

interface StatusAlertProps {
  message: string | null;
  variant?: 'success' | 'danger' | 'warning' | 'info';
}

export const StatusAlert = ({ message, variant = 'danger' }: StatusAlertProps) => {
  if (!message) {
    return null;
  }

  const isSuccess = message.includes('Congratulations') || message.includes('Skipping');
  const alertVariant = isSuccess ? 'success' : variant;

  return (
    <Alert
      variant={alertVariant}
      className="mb-3"
      style={{ borderRadius: '8px', border: 'none', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}
    >
      {message}
    </Alert>
  );
};
